import { render, staticRenderFns } from "./create-study-wizard.vue?vue&type=template&id=8526c442&scoped=true&"
import script from "./create-study-wizard.vue?vue&type=script&lang=ts&"
export * from "./create-study-wizard.vue?vue&type=script&lang=ts&"
import style0 from "./create-study-wizard.vue?vue&type=style&index=0&id=8526c442&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8526c442",
  null
  
)

export default component.exports